const gmpSections = document.querySelectorAll(".gmp-slider");
gmpSections.forEach((section) => {
  let current = 0;
  const prev = section.querySelector(".prev");
  const next = section.querySelector(".next");
  const slider = section.querySelector(".slider");
  const slides = section.querySelectorAll(".slide");
  let cardWidth = window.innerWidth > 1024 ? 332 : 274;

  //   prev.addEventListener("click", () => {
  //     current--;
  //     if (current < 0) {
  //       current = slides.length - 1;
  //     }
  //   });
  //   next.addEventListener("click", () => {
  //     current++;
  //     if (current >= slides.length) {
  //       current = 0;
  //     }
  //   });

  function nextSlide() {
    current++;
    if (current >= slides.length) {
      current = 0;
    }
    slider.style.transform = `translateX(-${current * 274}px)`;
    slides[current].classList.add("active");
    slides[current - 1].classList.remove("active");
  }
  function prevSlide() {
    current--;
    if (current < 0) {
      current = slides.length - 1;
    }
    slider.style.transform = `translateX(-${current * 274}px)`;

    setTimeout(() => {
      slides.forEach((slide, index) => {
        if (index != current) {
          slide.classList.remove("active");
        }
      });
      slides[current].classList.add("active");
    }, 500);
  }
  prev.addEventListener("click", prevSlide);
  next.addEventListener("click", nextSlide);

  window.addEventListener("resize", () => {
    cardWidth = window.innerWidth > 1024 ? 332 : 274;
    current = 0;
    slider.style.transform = `translateX(0px)`;
  });

  //   const slider = tns({
  //     container: section.querySelector(".slider"),
  //     autoPlay: true,
  //     controls: true,
  //     nav: false,
  //     loop: false,
  //     autoplayButtonOutput: false,
  //     controlsContainer: section.querySelector(".slider-controls"),
  //     fixedWidth: 266,
  //     speed: 500,
  //     gutter: 8,
  //     responsive: {
  //       1024: {
  //         disable: true,
  //       },
  //     },
  //   });
});
